//import "./styles.scss";
import React, { useEffect, useState } from "react";
import { Col, Container, FormGroup, Row, Card, CardImg, CardBody, CardText, Badge, Nav, NavItem, NavLink, TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Breadcrumb, BreadcrumbItem, CardTitle } from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import SideFilters from "components/Website/SideFilters";
import LineApexChart from "common/AllCharts/apex/chartapex"
import FilterPreview from "../Resale/FilterPreview"
import ResaleCard from "components/Website/Cards/ResaleCard";
import ResaleSearchService from "services/Website/ResaleSearchService"
import { Link } from "react-router-dom"
import Navbar from "components/Website/Layouts/Navbar"
import Footer from "components/Website/Layouts/Footer" 
import Paginator from "components/Website/Paginator"
import HomeService from "services/Website/HomeService"
import { SuccessOk } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters } from "store/filter/actions"
import { useTranslation } from 'react-i18next';

const ResaleArea = (props) => {
    const id = props.match.params.areaId
    const { t } = useTranslation();
    const filterData = useSelector(state => state.filter);
    const resaleService = new ResaleSearchService()
    const [resalesData, setResalesData] = useState([])
    const [filtersParams, setFilterParams] = useState(null)
    const [loading, setLoading] = useState(false);
    const [pricesData, setPriceData] = useState([])
    const [sizesData, setSizesData] = useState([])
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })

    const formatParamsHandler = (data) => {
        let value = ""
        for (let i = 0; i < data.length; i++) {
            if (i === 0) {
                value = data[i].value
            } else {
                value = `${value},${data[i].value}`
            }
        }
        return value
    }
    const dispatch = useDispatch();

    useEffect(() => {
        const resalesSizes = resalesData.map(resale => `${resale.size} sqt`)
        const resalesPrices = resalesData.map(resale => resale.payment_plan.total_price)
        setPriceData(resalesPrices)
        setSizesData(resalesSizes)
    }, [resalesData])

    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {
            setLoading(true)
            if(filterData.resale ?.trim().length  )   document.getElementById("resaleNamme").blur()
             if(filterData.ResaleLocation.length )   document.getElementById("locationNamme").blur()
             let params = {}
            if (filterData.resale ?.trim().length) params["keyword"] = filterData.resale.trim()
            if (filterData.ResaleLocation){
                params["location"] = filterData.ResaleLocation.value
            }else{
                params["location"] = id
            }
            params["budget"] = `${Math.round(filterData.budget[0])}-${Math.round(filterData.budget[1])}`
            params["area_sizs"] = `${Math.round(filterData.size[0])}-${Math.round(filterData.size[1])}`
            if (filterData.floor.length) params["floor"] = filterData.floor.join()
            if (filterData.bedrooms.length) params["bedrooms"] = filterData.bedrooms.join()
            if (filterData.bathrooms.length) params["bathrooms"] = filterData.bathrooms.join()
            if (filterData.paymentMethods.length) params["payment_type"] = filterData.paymentMethods.join()
            if (filterData.categories_ids.length) params["category_ids"] = formatParamsHandler(filterData.categories_ids)
            if (filterData.finishingType.length) params["finishing_type_ids"] = formatParamsHandler(filterData.finishingType)
            if (filterData.unitType.length) params["unit_type_ids"] = formatParamsHandler(filterData.unitType)
            setFilterParams({ ...params })
        }, 2000)
        return () => clearTimeout(timeoutId)
    }, [filterData])

    return (
        <React.Fragment>
            <Navbar />
            <div className="websitPages">
                <MetaTags>
                    <title>{t("Resales Page")}</title>
                </MetaTags>
                <div>
                    <Container fluid className="px-lg-5 pb-5 pt-4">
                        <Row className="justify-content-around">
                            <Col lg={3} sm={5}>
                                <SideFilters loading={loading} setLoading={setLoading} updateFilterHandler={(data) => { }} type="Resale" />
                            </Col>
                            <Col lg={9} sm={7} className="overflow-hidden">
                                <Breadcrumb className="mb-0 ms-0 bredWebsite">
                                    <BreadcrumbItem>
                                        <Link to='/'>{t("home")}</Link>
                                    </BreadcrumbItem>
                                    <BreadcrumbItem>
                                        <Link to='/resales'>{t("resales")}</Link>
                                    </BreadcrumbItem>
                                    <BreadcrumbItem active>
                                        {t("results")}
                                    </BreadcrumbItem>
                                </Breadcrumb>
                                {/* <CardText tag="h4">Resale</CardText> */ }
                                <Row>
                                    <FilterPreview />
                                </Row>
                                
                                {resalesData.length > 1 && <>
                                    <br /> 
                                    <CardText tag="h3" className="text-primary fw-bold">{t("top results")} </CardText>
                                    <p className="fobt-size-14">{t("advance subtitle")}</p>
                                    <LineApexChart pricesData={pricesData} sizesData={sizesData} />
                                    </>}
                                <hr />

                                <CardText tag="h4" className="pt-3 text-primary">{t("another result")} </CardText>
                                <Row>
                                    {resalesData.map((resale, index) => {
                                        return (
                                            <Col xl={4} md={6} key={index}>
                                                <ResaleCard resale={resale} history={props.history} loaction={props.loaction} />
                                            </Col>)
                                    })}
                                </Row>
                            </Col>
                        </Row>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-end" md={12}>
                                <Paginator
                                    service={resaleService}
                                    pageOptions={pageOptions}
                                    setData={(data) => {
                                        setResalesData([...data])
                                        setLoading(false)
                                    }}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={false}
                                    setShouldGetData={() => { }}
                                />
                            </Col>
                        </Row >
                    </Container>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
};

export default ResaleArea;